// extracted by mini-css-extract-plugin
export default {"link":"EditorRestrictionModal__link--34gyC"};